/** @graphql cc **/

import gql from 'graphql-tag';

export const PageTreeRootLevelPagesQuery = gql`
	query PageTreeRootLevelPagesQuery(
		$spaceKey: String!
		$statuses: [GraphQLPageStatus]
		$ptStatuses: [PTGraphQLPageStatus]
		$isSuperAdmin: Boolean!
		$paginationLimit: Int
		$isReplacePagesWithPTPageEnabled: Boolean! = false
	) {
		ptpage(spaceKey: $spaceKey, status: $ptStatuses, pageTree: $paginationLimit)
			@include(if: $isReplacePagesWithPTPageEnabled) {
			id
			title
			status
			createdDate(format: MILLIS) {
				value
			}
			hasChildren
			blank
			hasRestrictions @include(if: $isSuperAdmin)
			hasInheritedRestrictions @include(if: $isSuperAdmin)
			type
			subType
			links {
				webui
			}
			properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
				nodes {
					id
					key
					value
					version {
						number
					}
				}
			}
			followingSiblings {
				nodes {
					id
					title
					status
					createdDate(format: MILLIS) {
						value
					}
					hasChildren
					blank
					hasRestrictions @include(if: $isSuperAdmin)
					hasInheritedRestrictions @include(if: $isSuperAdmin)
					type
					subType
					links {
						webui
					}
					properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
						nodes {
							id
							key
							value
							version {
								number
							}
						}
					}
				}
				pageInfo @include(if: $isReplacePagesWithPTPageEnabled) {
					hasNextPage
				}
			}
		}
		rootLevelPages: pages(spaceKey: $spaceKey, status: $statuses, limit: $paginationLimit)
			@skip(if: $isReplacePagesWithPTPageEnabled) {
			nodes {
				id
				hasChildren
				title
				status
				blank
				hasRestrictions @include(if: $isSuperAdmin)
				hasInheritedRestrictions @include(if: $isSuperAdmin)
				type
				properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				links {
					webui
				}
			}
		}
		space(key: $spaceKey) {
			id
			homepage {
				id
			}
			operations {
				operation
				targetType
			}
		}
	}
`;
